/**
 * @generated SignedSource<<d66bc3c1721b856aa5cb4b75929a3d59>>
 * @relayHash 05121d91dabaeb1256fcb9012d73ba65
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c83d09eb0de6a3bf710d7364431c8200591175f07d8ff8317f01a5255ea13554

import type { ConcreteRequest } from 'relay-runtime';
export type useAudioContentQuery$variables = {
  contentId: string;
};
export type useAudioContentQuery$data = {
  readonly singleContent: {
    readonly emoji: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null | undefined;
        readonly value: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly history: {
      readonly createdBy: {
        readonly displayName: string | null | undefined;
        readonly profilePicture: {
          readonly path: string;
        } | null | undefined;
      } | null | undefined;
      readonly ownedBy: {
        readonly displayName: string | null | undefined;
        readonly profilePicture: {
          readonly path: string;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
    readonly links: {
      readonly base: string | null | undefined;
      readonly webui: string | null | undefined;
    } | null | undefined;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly key: string | null | undefined;
        readonly value: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly subType: string | null | undefined;
    readonly title: string | null | undefined;
  } | null | undefined;
};
export type useAudioContentQuery = {
  response: useAudioContentQuery$data;
  variables: useAudioContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "title"
},
v4 = {
  "kind": "ScalarField",
  "name": "subType"
},
v5 = {
  "kind": "ScalarField",
  "name": "value"
},
v6 = {
  "alias": "emoji",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "emoji-title-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v5/*: any*/)
      ]
    }
  ],
  "storageKey": "properties(key:\"emoji-title-published\")"
},
v7 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v8 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v9 = [
  (v7/*: any*/),
  (v8/*: any*/)
],
v10 = {
  "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    },
    {
      "kind": "ScalarField",
      "name": "base"
    }
  ]
},
v11 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "emoji-title-published",
        "editor"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        {
          "kind": "ScalarField",
          "name": "key"
        }
      ]
    }
  ],
  "storageKey": "properties(keys:[\"emoji-title-published\",\"editor\"])"
},
v12 = [
  {
    "kind": "ScalarField",
    "name": "__typename"
  },
  (v7/*: any*/),
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useAudioContentQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v6/*: any*/),
          {
            "concreteType": "History",
            "kind": "LinkedField",
            "name": "history",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "createdBy",
                "plural": false,
                "selections": (v9/*: any*/)
              },
              {
                "kind": "LinkedField",
                "name": "ownedBy",
                "plural": false,
                "selections": (v9/*: any*/)
              }
            ]
          },
          (v10/*: any*/),
          (v11/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAudioContentQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v6/*: any*/),
          {
            "concreteType": "History",
            "kind": "LinkedField",
            "name": "history",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "createdBy",
                "plural": false,
                "selections": (v12/*: any*/)
              },
              {
                "kind": "LinkedField",
                "name": "ownedBy",
                "plural": false,
                "selections": (v12/*: any*/)
              }
            ]
          },
          (v10/*: any*/),
          (v11/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "05121d91dabaeb1256fcb9012d73ba65",
    "id": "c83d09eb0de6a3bf710d7364431c8200591175f07d8ff8317f01a5255ea13554",
    "metadata": {},
    "name": "useAudioContentQuery",
    "operationKind": "query",
    "text": "query useAudioContentQuery($contentId:ID!){singleContent(id:$contentId){id,title,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},history{createdBy{__typename,displayName,profilePicture{path}},ownedBy{__typename,displayName,profilePicture{path}}},links{webui,base},properties(keys:[\"emoji-title-published\",\"editor\"]){nodes{value,key}}}}"
  }
};
})();

(node as any).hash = "a697f593a36975591a0fa8257ca3e174";

export default node;
